import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-washes",
  "use": "icon-ic-list-washes-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-washes\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-16.67S7 10 7 13.69a5 5 0 0 0 10 0c0-3.69-5-8.36-5-8.36zm-1.13 11.58a3.698 3.698 0 0 1-2.15-2.14 4.46 4.46 0 0 1 .64-3.55l.87.49c-.558.8-.76 1.795-.56 2.75A2.76 2.76 0 0 0 11.29 16l-.42.91z\" fill=\"#007FBA\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol